import React, { useEffect, useState } from 'react';
import ellipse1 from '../../../../assets/img/ellipse1.svg';
import ellipse2 from '../../../../assets/img/ellipse2.svg';
import ellipse3 from '../../../../assets/img/ellipse3.svg';
import ellipse4 from '../../../../assets/img/ellipse4.svg';
import time2 from '../../../../assets/img/time-date.svg';
import arroTop from '../../../../assets/img/arro-top.svg';
import APIServices from 'services/APIServices';
import { set } from 'lodash';
import { selectLoader } from 'utils/Helpers';
import ModalCenter from 'components/ModalCenter';
import BusinessProfileForm from 'components/BusinessProfileForm';
import { useAuth } from 'contexts/AuthContext';

const ChangeOrderOptionSelector = ({ projectRequestId, onGenerated, industryOptions }) => {
  const { user, isOwner } = useAuth();
  const [selectedOption, setSelectedOption] = useState(null);
  const [aiGuide, setAiGuide] = useState('');
  const [showGuide, setShowGuide] = useState(false);
  const [isGuideOpen, setIsGuideOpen] = useState(false);
  const [isModalopen, setIsModalopen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [businessProfile, setBusinessProfile] = useState({
    businessVerticalIndustry: null,
    businessDescription: '',
    laborRateCostStructure: {
      hourlyLaborRate: 0,
      markup: 0,
      overheadProfit: 0
    }
  });

  const isBusinessProfileComplete = (profile) => {
    return !!profile?.businessVerticalIndustry?.optionId && !!profile?.businessDescription?.trim();
  };

  const handleGenerate = async () => {
    if (!selectedOption) return;

    try {
      setLoading(true);

      // ✅ ONLY owners need business profile validation
      // if (isOwner) {
      const settingsResponse = await APIServices.get(`/user-settings/${user._id}`);

      const profile = settingsResponse?.businessProfile;

      if (profile) {
        setBusinessProfile(profile);
      }

      // validate owner profile
      if (!isBusinessProfileComplete(profile)) {
        setIsModalopen(true);
        return;
      }
      // }

      // ✅ generate directly for non-owner
      await generateOptions();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const generateOptions = async () => {
    try {
      setLoading(true);

      const payload = {
        projectRequestId,
        optionCount: selectedOption,
        quoteContext: aiGuide || ''
      };

      const response = await APIServices.post('/project-request-quote/ai-generate', payload);

      onGenerated(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveBusinessProfile = async () => {
    try {
      setLoading(true);

      // update settings
      await APIServices.put(`/user-settings/${user._id}`, {
        businessProfile
      });

      // close modal
      setIsModalopen(false);

      // NOW generate options
      await generateOptions();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSelectedOption(3);
    setShowGuide(true);
    setIsGuideOpen(true);
  }, []);

  return (
    <div>
      <div className="changeOder-card">
        <div className="changeOder-content">
          <div className="changeOder-header">
            <label>How many options?</label>
            <p>Each option is a tier - Premium is always first. Most estimates close with 3.</p>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div
                className={`estimates-card ${selectedOption === 1 ? 'estimates-card-active' : ''}`}
                onClick={() => {
                  setSelectedOption(1);
                  setShowGuide(true);
                }}>
                <span>1</span>
                <img src={ellipse1} alt="File" className="ellipse1" />
                <p>Single Option</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div
                className={`estimates-card ${selectedOption === 2 ? 'estimates-card-active' : ''}`}
                onClick={() => {
                  setSelectedOption(2);
                  setShowGuide(true);
                }}>
                <span>2</span>
                <img src={ellipse2} alt="File" className="ellipse1" />
                <p>Compare</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div
                className={`estimates-card ${selectedOption === 3 ? 'estimates-card-active' : ''}`}
                onClick={() => {
                  setSelectedOption(3);
                  setShowGuide(true);
                }}>
                <span>3</span>
                <img src={ellipse3} alt="File" className="ellipse1" />
                <p>Best/Better/Good</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div
                className={`estimates-card ${selectedOption === 4 ? 'estimates-card-active' : ''}`}
                onClick={() => {
                  setSelectedOption(4);
                  setShowGuide(true);
                }}>
                <span>4</span>
                <img src={ellipse4} alt="File" className="ellipse1" />
                <p>Full Range</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="optional-title">
                <p>Guide the AI on how to structure tiers (Optional)</p>
              </div>
              {isGuideOpen && showGuide && (
                <div className="optional-discription">
                  <textarea
                    value={aiGuide}
                    onChange={(e) => setAiGuide(e.target.value)}
                    placeholder="Guide the AI..."
                    className="form-control"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="changeOder-btn-cover">
        <button className="btn-black w-full" disabled={!selectedOption || loading} onClick={handleGenerate}>
          {loading ? <span className='generate_loader'>{selectLoader(20)} Generating with AI</span> : 'Generate options'}
        </button>
      </div>
      {/* {isOwner && ( */}
      <ModalCenter
        extraClass={'override-modal'}
        show={isModalopen}
        headerTitle={'Company Bio'}
        closeModal={() => {
          setIsModalopen(false);
        }}>
        <BusinessProfileForm
          value={businessProfile}
          onChange={setBusinessProfile}
          industryOptions={industryOptions}
          isFromOptions={true}
          onSubmit={handleSaveBusinessProfile}
        />
      </ModalCenter>
      {/* )} */}
    </div>
  );
};

export default ChangeOrderOptionSelector;
